import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home'
import Instructions from '@/views/Instructions'
import Leaderboard from '@/views/Leaderboard'

import Login from '@/views/auth/Login'
import Logout from '@/views/auth/Logout'
import ConfirmDelete from '@/views/auth/ConfirmDelete'
import Signup from '@/views/auth/Signup'
import Account from '@/views/auth/Account'
import PasswordReset from '@/views/auth/PasswordReset'
import UpdateInfo from '@/views/auth/UpdateInfo'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/instructions',
    component: Instructions
  },
  {
    path: '/leaderboard',
    component: Leaderboard
  },
  {
    path: '/video',
    redirect: '/'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/logout',
    component: Logout
  },
  {
    path: '/deleted',
    component: ConfirmDelete
  },
  {
    path: '/signup',
    component: Signup
  },
  {
    path: '/account',
    component: Account
  },
  {
    path: '/password-reset',
    component: PasswordReset
  },
  {
    path: '/update-info',
    component: UpdateInfo
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition

    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return false
  }
})

// router.afterEach(() => {
//   window.scrollTo(0, 0)
// })

export default router
